module.exports = __webpack_public_path__ + "assets/img/gn2.123cda6d.png";